import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { HiChartBar, HiHome, HiQuestionMarkCircle, HiBars3, HiXMark, HiInformationCircle } from 'react-icons/hi2'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const handleLinkClick = () => {
    setMobileMenuOpen(false)
  }

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="bg-black shadow-sm border-b border-gray-800 sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-2">
                <img src="/fanalyzesv2.png" alt="fanalyzes" className="h-10 w-auto max-w-[144px]" />
              </Link>
            </div>
            <div className="flex items-center space-x-2">
              <button
                type="button"
                aria-label="Toggle navigation"
                className="md:hidden inline-flex items-center justify-center rounded-md border border-gray-800 p-2 text-gray-300 hover:text-white hover:border-gray-600 focus:outline-none focus:ring-2 focus:ring-primary-500"
                onClick={() => setMobileMenuOpen((prev) => !prev)}
              >
                {mobileMenuOpen ? <HiXMark className="h-5 w-5" /> : <HiBars3 className="h-5 w-5" />}
              </button>

              <nav className="hidden md:flex md:items-center md:space-x-8">
                <Link
                  to="/"
                  className="flex items-center space-x-1 text-gray-300 hover:text-white transition-colors"
                >
                  <HiHome className="h-4 w-4" />
                  <span>Home</span>
                </Link>
                <Link
                  to="/how-it-works"
                  className="flex items-center space-x-1 text-gray-300 hover:text-white transition-colors"
                >
                  <HiQuestionMarkCircle className="h-4 w-4" />
                  <span>How it Works</span>
                </Link>
                <Link
                  to="/analytics"
                  className="flex items-center space-x-1 text-gray-300 hover:text-white transition-colors"
                >
                  <HiChartBar className="h-4 w-4" />
                  <span>Analytics</span>
                </Link>
                <Link
                  to="/info"
                  className="flex items-center space-x-1 text-gray-300 hover:text-white transition-colors"
                >
                  <HiInformationCircle className="h-4 w-4" />
                  <span>Info</span>
                </Link>
              </nav>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-gray-800 bg-zinc-950/95 backdrop-blur-sm">
            <div className="px-4 py-3 space-y-1">
              <Link
                to="/"
                onClick={handleLinkClick}
                className="flex items-center space-x-2 rounded-lg px-3 py-2 text-gray-200 hover:bg-gray-900"
              >
                <HiHome className="h-4 w-4" />
                <span>Home</span>
              </Link>
              <Link
                to="/how-it-works"
                onClick={handleLinkClick}
                className="flex items-center space-x-2 rounded-lg px-3 py-2 text-gray-200 hover:bg-gray-900"
              >
                <HiQuestionMarkCircle className="h-4 w-4" />
                <span>How it Works</span>
              </Link>
              <Link
                to="/analytics"
                onClick={handleLinkClick}
                className="flex items-center space-x-2 rounded-lg px-3 py-2 text-gray-200 hover:bg-gray-900"
              >
                <HiChartBar className="h-4 w-4" />
                <span>Analytics</span>
              </Link>
              <Link
                to="/info"
                onClick={handleLinkClick}
                className="flex items-center space-x-2 rounded-lg px-3 py-2 text-gray-200 hover:bg-gray-900"
              >
                <HiInformationCircle className="h-4 w-4" />
                <span>Info</span>
              </Link>
            </div>
          </div>
        )}
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <div className="text-center text-gray-400 text-xs sm:text-sm space-y-2">
            <p>fanalyzes.com (Beta v0.1)</p>
            <p className="leading-relaxed">Powered by an enhanced XLM-RoBERTa (Multilingual Masked Language Model)</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Layout

